<template>
	<a :href="itemLink" v-show="!hideItem" class="card lesson-card h-full" :class="{
		'is-complete': item.is_completed,
		'card-horizontal block md:flex': horizontalCard,
		'block': !horizontalCard
	}">
		<div class="card-media" :style="cardMediaStyle" v-waves.block.light>
			<img class="card-media-image" :src="item.preview" v-if="item.preview" alt="">

			<card-status :item="item"></card-status>
			<span class="card-label card-label-orange card-label-floating">Lesson</span>
		</div>
		<div class="card-content">
			<div class="absolute right-0 mr-6 md:mr-5" v-if="item.removable">
				<a href="#" @click.prevent="removeLesson()">
					<i class="tbb-icon-times text-2xl"></i>
				</a>
			</div>
			<h4 class="card-title mr-6">{{ item.title }}</h4>

			<div class="card-info small">
				<card-difficulty :item="item"></card-difficulty>
				<span class="card-info-item">
					<strong>{{ item.time_span }}</strong> day{{ item.time_span > 1 ? 's' : '' }}
				</span>
			</div>

			<div class="card-actions">
				<!-- <favorite-toggle :item="item"></favorite-toggle> -->
			</div>
		</div>
	</a>
</template>

<script>
import ListItem from '../mixins/base-list-item';
import Favorite from '../components/favorite-toggle.vue';
import Http from '../mixins/http';

export default {
	mixins: [ListItem, Http],

	data() {
		return {
			horizontalCard: false,
			hideItem: false
		}
	},

	computed: {
		cardMediaStyle() {
			if (!this.horizontalCard) {
				return '';
			}

			return 'background-image:url(' + this.item.preview + ')';
		},

		itemLink() {
			let linkBase = '/lessons/' + this.item.slug;

			if (this.item.course) {
				linkBase = '/courses/' + this.item.course.slug + '/' + parseInt(this.index + 1, 10);
			}

			return linkBase + '/overview';
		}
	},

	components: {
		'favorite': Favorite
	},

	methods: {

		/**
		 * Remove an item...
		 */
		removeLesson() {
			this.$confirm('Remove lesson from in progress?', 'Warning', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				type: 'warning'
			}).then(() => {
				this.sendRequest('/api/lesson/remove-progress/' + this.item.id, 'post', this.lessonRemoved)
			}).catch(() => {
				this.$message({
					type: 'info',
					message: 'Lesson removal canceled'
				});
			});
		},

		/**
		 * Hide lesson from view...
		 *
		 * @param data
		 * @param message
		 */
		lessonRemoved(data, message) {
			this.hideItem = true;
			this.$message({
				type: message.type,
				message: message.content
			});
		}
	}
}
</script>
